export default __webpack_public_path__ + "static/media/il-borgo-gallery-6-moris-lorenzi.20780cf9.jpg";